import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { environment } from './../../../../../environments/environment';
import { IAgendaEduLog } from '../../../../../interfaces/iagenda-edu-log';
import { IFatura } from './../../../../../interfaces/ifatura';
import { IFaturaDetalhada } from '../../../../../interfaces/ifatura-detalhada';
import { Fatura } from './../../../../../utils/fatura';
import { LogService } from '../../../../../services/log.service';

@Component({
  selector: 'eae-nav-fatura-detalhada-pix',
  templateUrl: './eae-nav-fatura-detalhada-pix.component.html',
  styles: [],
})
export class EaeNavFaturaDetalhadaPixComponent implements OnInit {
  @Input()
  fatura!: IFatura;
  @Input()
  faturaDetalhada!: IFaturaDetalhada;
  @Input()
  showTicket: boolean = true;

  showPorquePagarComPix: boolean = false

  copied: boolean = false;
  timeElapsed: number = 3000;
  diasMaximoAtraso: number = environment.diasMaximoAtraso;
  constructor(private logService: LogService) {}

  ngOnInit(): void {}

  public logCardDetail(fatura: IFatura, message: string) {
    let cardDetailLog: IAgendaEduLog = {
      responsibleToken: '',
      studentToken: '',
      message: message,
      category: Fatura.categoryAcessoFatura,
      urlOrigem: `/fatura/${fatura.bankSliptId}`,
      bankSlipAgendaEdu: fatura,
    };

    return this.logService.logAgendaEdu(cardDetailLog);
  }

  public logCardDetailCopyPix(fatura: IFatura, message: string) {
    let cardDetailLog: IAgendaEduLog = {
      responsibleToken: '',
      studentToken: '',
      message: message,
      category: Fatura.categoryCopyPix,
      urlOrigem: `/fatura/${fatura.bankSliptId}`,
      bankSlipAgendaEdu: fatura,
    };
    
    return this.logService.logAgendaEdu(cardDetailLog).subscribe();
    
  }

  public isDateOverDueMoreThanAnyDays(dateFatura: string, days: number): boolean {
    return Fatura.isDateOverDueMoreThanAnyDays(dateFatura, days);
  }

  public accessFatura(e: Event): void {
    e.preventDefault();
    this.logCardDetail(this.fatura, 'VISUALIZAR FATURA PIX')
      .subscribe(
        data => 
        {
          window.open(this.fatura.bankSliptUrl, '_blank')
        }
      );
  }

  public copyCode(e: Event): void {
    e.preventDefault();
    this.showFeedBackCopied();
  
    this.fatura.codigoPix = this.faturaDetalhada.linhaDigitavelTratada
    this.logCardDetailCopyPix(this.fatura, 'COPIAR CÓDIGO PIX');
  }

  public showFeedBackCopied(): void {
    this.copied = true;
    
  }

  @Output() onSetShowTicket: EventEmitter<Event> = new EventEmitter<Event>();
  clickShowTicket(e: Event): void {
    e.preventDefault()
    this.onSetShowTicket.emit(e);
  }

  setShowPorquePagarComPix (status: boolean): void {
    this.showPorquePagarComPix = status
  }
}
